export default {
  namespaced: true,
  app_modules: {
    title: "Módulo App | Módulos App"
  },
};
